import React from "react"
import HelperMore from "./_helperMore"
import { FlowGetfocusToSelect } from "src/helpers/Flows/TableCell"
import { HCF } from "@macashipo/mlib"
import { KConfigApp } from "src/helpers/K"
const BaseText = props => {
  const more = HelperMore.getMoreFromProps(props) || {}
  let _moreProps = {}
  if (HCF.getCF(KConfigApp.showDataField) == true) {
    if (props.fieldName) {
      _moreProps["data-field"] = props.fieldName
    }
  }
  return (
    <textarea
      spellCheck="false"
      // value={props.value}
      {...HelperMore.getPropsValues(props, { defaultValueWhenNull: "" })}
      onChange={ev => {
        props.onChange && props.onChange(ev.currentTarget.value)
      }}
      onBlur={ev => {
        props.onBlur && props.onBlur(ev.currentTarget.value)
      }}
      onFocus={ev => {
        if (FlowGetfocusToSelect({ more })) {
          // console.log("focustToSelect")
          if (ev && ev.target && ev.target.select) {
            ev.target.select()
          }
        }
      }}
      className={props.className}
      style={props.style}
      {...props.attrs}
      {..._moreProps}
    />
  )
}

export default BaseText
